module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABKElEQVQ4jW2TUa7sIAxDT0Z3X2RnNTsLK/P7oDBM+yKhQmVsE0PY5qyIMIA01+trO3hURBCLICK80AKuS4xRG5xVIP0QRQSftVkStxgCnnKVCdJ2uOqzFTLJzE3yrGxtkjzqs9SrahM9SbI1aozp7uFiOxAi66ugrtfmJfA+gsCX8QV1kFQV6n3P/1cBWHf3F/sPWHNkJpXFxUUQ2I6I4O9EtmbGGFzXRe8zh+uOeYwBgq7+cmHbripLOubYxlXlqtr/bzzr/nwWe2vt9juPkFn0Q2wcjXyl8I2wiIibZPajtaS13JhnM3eMS2ECtAG9wxhFZt4uf12E7X2Vz+ZlFlWJBDbHcSb5nVxsB1Ots3I7rfau+51pbfw+qqOjlmRJBl7jTohzAPwDGonmOJBV8sQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/CDSAMPLE_16.png
// module id = 48
// module chunks = 0